import './App.css';
import Home from './home/Home';
import About from './about/About';
import Contact from './contact/Contact';
import CyberSecurityService from './cybersecurityservice/CyberSecurityService';
import CyberSecuritySolution from './cybersecuritysolution/CyberSecuritySolution';
import ArtificialIntelligence from './artificialintelligence/ArtificialIntelligence';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

function App() {
  return (
   <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/cyber-security-service" element={<CyberSecurityService />} />
      <Route path="/cyber-security-solution" element={<CyberSecuritySolution />} />
      <Route path="/artificial-intelligence" element={<ArtificialIntelligence />} />
    </Routes>
   </BrowserRouter>
  );
}

export default App;
